export const normalizeText = (text: string): string => {
  return text
    .toLowerCase()
    // Remove acentos
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    // Remove caracteres especiais mantendo espaços
    .replace(/[^a-z0-9\s]/g, ' ')
    // Remove espaços extras
    .replace(/\s+/g, ' ')
    .trim();
};